<template>
  <section class="status-section-loader">
    <div class="ds-container ds-padding-top-48">
      <div class="ds-grid ds-justify-content-center">
        <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--10">
          <div class="ds-margin-bottom-24">
            <div
              class="status-loading"
              :style="{ height: '30px', width: isScreenSmall ? '200px' : '289px' }"
            />
          </div>
          <ul>
            <li
              v-for="index in itemsToLoad"
              :key="`status-maintenance-card-loading-${index}`"
              class="ds-width-full"
            >
              <StatusCard :tag-label="isIncident ? 'mock label' : null" :class="{ 'ds-margin-top-12': index !== 1 }">
                <StatusItem v-if="isIncident" />
                <span v-else class="ds-display-flex ds-flex-direction-column">
                  <span
                    v-for="index in 4"
                    :key="`status-item-description-loading-${index}`"
                    class="ds-margin-top-6 status-loading status-section-loader__description--loading"
                    :class="[
                      `status-section-loader__description--loading--${index}`,
                      { 'ds-margin-top-12': index === 1 }
                    ]"
                    :style="{ height: '20px' }"
                  />
                </span>
              </StatusCard>
            </li>
            <li class="ds-margin-top-24">
              <div
                class="status-loading"
                :style="{ height: '20px', width: '174px' }"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { StatusCard, StatusItem } from '@/components'
import { MESSAGE_TYPE } from '@/constants'
import { isScreenSmall } from '@/utils/screen'

export default {
  name: 'StatusSectionLoader',
  inject: ['screen'],
  components: { StatusCard, StatusItem },
  props: {
    type: { type: String, required: true, validator: str => ['maintenance', 'incident'].includes(str) },
    isOpen: { type: Boolean, default: false },
    itemsToLoad: { type: Number, default: 3 }
  },
  computed: {
    cardColor () {
      return this.isIncident ? 'light' : 'grey'
    },
    isIncident () {
      return this.type === MESSAGE_TYPE.INCIDENT
    },
    isScreenSmall () {
      return isScreenSmall(this.screen.name)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'website-design-system/src/foundation/tokens/variables';
@import 'website-design-system/src/foundation/mixins/mixins';

.status-section-loader {
  &__description {
    display: block;
    margin-top: $spacing-12;

    &--loading {
      width: 173px;

      @include screen ('medium') {
        width: 367px;
      }

      &--2 {
        width: 205px;

        @include screen ('medium') {
          width: 433px;
        }
      }

      &--3 {
        width: 231px;

        @include screen ('medium') {
          width: 489px;
        }
      }
    }
  }
}
</style>
